export default __webpack_public_path__ + "static/media/bot.7e3be455.png";